import { render, staticRenderFns } from "./attestation-add.vue?vue&type=template&id=5bdd832c&scoped=true&"
import script from "./attestation-add.vue?vue&type=script&lang=js&"
export * from "./attestation-add.vue?vue&type=script&lang=js&"
import style0 from "./attestation-add.vue?vue&type=style&index=0&id=5bdd832c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd832c",
  null
  
)

export default component.exports